import React from "react";

const meta = [
    { k: "Trading name", v: "FreshEdge Services" },
    { k: "Based", v: "Queanbeyan · Canberra · ACT" },
    { k: "Crew", v: "Two-person, owner-run" },
    { k: "Cover", v: "Public liability insured" },
];

export default function About() {
    return (
        <section
            id="about"
            data-testid="section-about"
            className="relative bg-[var(--paper)] py-28 md:py-40 border-t border-line"
        >
            <div className="maxw section-pad">
                <div className="grid md:grid-cols-12 gap-12">
                    <div className="md:col-span-7">
                        <div className="eyebrow mb-5">About</div>
                        <h2 className="font-display font-light text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight max-w-2xl">
                            A small local crew that takes the{" "}
                            <span className="italic text-[var(--terra)]">
                                detail
                            </span>{" "}
                            seriously.
                        </h2>

                        <div className="mt-10 flex items-center gap-5">
                            <div
                                className="w-20 h-20 rounded-full overflow-hidden flex items-center justify-center text-[var(--paper)] font-display text-3xl tracking-tight shrink-0 relative"
                                style={{
                                    background:
                                        "linear-gradient(135deg, #5c7d3a 0%, #3f5a24 60%, #1f2c12 100%)",
                                }}
                                data-testid="portrait"
                            >
                                FE
                                <span className="absolute inset-0 grain" />
                            </div>
                            <div>
                                <div className="font-display text-xl">
                                    FreshEdge Services
                                </div>
                                <div className="font-mono-x text-[12px] text-[rgba(14,14,16,0.58)] mt-1">
                                    Owner-run · Two-person crew
                                </div>
                            </div>
                        </div>

                        <div className="mt-10 max-w-2xl text-[rgba(14,14,16,0.75)] text-[15.5px] leading-[1.75]">
                            <h3 className="font-display text-2xl font-medium text-[var(--ink)] mb-4">
                                Hi, we’re FreshEdge.
                            </h3>
                            <p>
                                FreshEdge Services is a local property
                                maintenance business{" "}
                                <strong className="text-[var(--ink)] font-semibold">
                                    run by two hardworking teens
                                </strong>{" "}
                                who take pride in reliable communication, neat
                                results, and quality outdoor work. We help with
                                lawn mowing, garden maintenance, weeding, hedge
                                trimming, yard cleanups, pressure washing,
                                outdoor cleaning, and general property
                                maintenance across Queanbeyan, Canberra,
                                Tuggeranong and surrounding areas.
                            </p>
                            <p className="mt-4">
                                We focus on quality work, neat finishes and
                                easy communication. We turn up on time, finish
                                what we start, and clean up before we leave.
                                Whether it’s a single mow, a weekend cleanup or
                                a regular tidy, we’ll quote it fairly and do it
                                properly.
                            </p>
                        </div>

                        <div className="mt-10 flex flex-wrap gap-3">
                            <a href="#contact" className="btn-ink" data-testid="about-cta">
                                Get a Free Quote
                                <span>→</span>
                            </a>
                            <a
                                href="#services"
                                className="btn-ghost"
                                data-testid="about-cta-2"
                            >
                                See what we do
                            </a>
                        </div>
                    </div>

                    <aside className="md:col-span-5">
                        <div className="border border-line rounded-2xl overflow-hidden">
                            {meta.map((m, i) => (
                                <div
                                    key={m.k}
                                    className={`flex items-center justify-between px-6 py-5 ${
                                        i < meta.length - 1
                                            ? "border-b border-line"
                                            : ""
                                    }`}
                                >
                                    <span className="eyebrow">{m.k}</span>
                                    <span className="font-display text-[17px] tracking-tight text-[var(--ink)] text-right">
                                        {m.v}
                                    </span>
                                </div>
                            ))}
                        </div>

                        <div className="mt-6 rounded-2xl border border-line p-6 md:p-7 bg-[rgba(233,226,211,0.5)]">
                            <div className="eyebrow mb-4">What you can expect</div>
                            <ul className="flex flex-col gap-3 text-[14.5px]">
                                {[
                                    { t: "Reply within", v: "Usually < 5 hours" },
                                    { t: "Quotes are", v: "Free, no obligation" },
                                    { t: "On the day", v: "Text on arrival" },
                                    { t: "After the job", v: "Photo + tidy walkthrough" },
                                ].map((r) => (
                                    <li
                                        key={r.v}
                                        className="flex items-baseline justify-between gap-4 border-b border-line last:border-0 pb-3 last:pb-0"
                                    >
                                        <span className="text-[rgba(14,14,16,0.6)]">
                                            {r.t}
                                        </span>
                                        <span className="font-display text-[16.5px] tracking-tight text-[var(--ink)] text-right">
                                            {r.v}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </aside>
                </div>
            </div>
        </section>
    );
}
